import { useVersionStore } from '@/store/versionStore';
import APP_METADATA from '@/constants/AppMetadata';
import services from '@/services/services';
import { IApiVersion } from '@/interfaces/IApiVersion';
import { IAppVersion } from '@/interfaces/IAppVersion';

export default function versionLogic() {
  const versionStore = useVersionStore();

  // **Initialize App Version**
  const appVersion: IAppVersion = {
    name: APP_METADATA.app_info_name,
    title: APP_METADATA.app_info_name, //temp fix needed the gulp to be updated to add the title and update the package.json to have the display name
    version: APP_METADATA.app_info_version,
    lastUpdated: APP_METADATA.app_info_released_on,
    releaseSignature: APP_METADATA.app_info_branch,
    environment: APP_METADATA.app_info_env,
  };

  function addAppVersion() {
    versionStore.addAppVersion(appVersion);
  }

  async function updateApiVersionByServiceName(
    serviceName: string
  ): Promise<void> {
    const apiService = services.find(
      (service) => service.serviceName === serviceName
    );

    if (apiService && typeof apiService.service.apiinfo === 'function') {
      // Set isLoading to true
      versionStore.setVersionLoading(serviceName, true);

      try {
        const data: IApiVersion | null = await apiService.service.apiinfo();
        if (data) {
          versionStore.updateApiVersion(data);
        } else {
          // Handle error state
          versionStore.updateApiVersion({
            name: serviceName,
            title: serviceName,
            version: 'Error',
            lastUpdated: '',
            releaseSignature: 'Failed to fetch version info',
            environment: '',
            lastFetched: new Date(),
            isLoading: false,
            isSuccess: false,
          });
        }
      } catch (error) {
        console.error(`Error updating version for ${serviceName}:`, error);
        // Handle error state
        versionStore.updateApiVersion({
          name: serviceName,
          title: serviceName,
          version: 'Error',
          lastUpdated: '',
          releaseSignature: 'Failed to fetch version info',
          environment: '',
          lastFetched: new Date(),
          isLoading: false,
          isSuccess: false,
        });
      }
    }
  }

  async function initApiVersion(): Promise<void> {
    const servicePromises = services.map(async (api) => {
      if ('service' in api && typeof api.service.apiinfo === 'function') {
        // Add initial version with loading state
        versionStore.addApiVersion(api.serviceName);
        await updateApiVersionByServiceName(api.serviceName);
      }
    });

    await Promise.all(servicePromises);
  }

  return {
    addAppVersion,
    updateApiVersionByServiceName,
    initApiVersion,
  };
}
